export const SET_HOVER = "SET_HOVER";
export const SET_DIMS = "SET_DIMS";
export const SET_FIXED_DIMS = "SET_FIXED_DIMS";

export interface HoverElement {
    row: number;
    col: number;
}

export interface DimElement {
    width: number[];
    height: number[];
}

export interface DimActionElement {
    rowIndex: number;
    el: HTMLTableRowElement;
    width: Array<number>;
}

export interface SetHoverAction {
    type: typeof SET_HOVER;
    data: HoverElement;
}

export interface SetDimsAction {
    type: typeof SET_DIMS | typeof SET_FIXED_DIMS;
    data: DimActionElement;
}
